<div class="d-block h-100 w-100">
    <div class="d-flex flex-row h-100 overflow-auto w-100">
        <ng-content></ng-content>
    </div>
</div>
